module.exports = __webpack_public_path__ + "img/404.bc27c0ec.png";